import React from 'react';
import PropTypes from 'prop-types';
import { FilterSection } from './filter_section';
import { FilterSelect } from './filters/filter_select';
import TranslationContainer from '../../../translation/translation_container';
import { Filters } from '../../../../constants/filter/filters';
import { FilterLabelTranslationKeys } from '../../../../constants/filter/filter_label_translation_keys';

function Additional(props) {
    const opened = props.opened || !!props.vehicleTypeValue;
    const vehicleTypeTranslationKey = FilterLabelTranslationKeys[Filters.VEHICLE_TYPE];

    return (
        <FilterSection
            opened={opened}
            resettable={props.resettable}
            onActionClick={props.onActionClick}
            headline="catalog-filters-section-headline-additional"
            containerModifier="additional"
        >
            <TranslationContainer
                targetProperties={{
                    tooltipContent: { translationKey: 'catalog-filter-vehicle-type-tooltip-text' },
                }}
            >
                <FilterSelect
                    name={Filters.VEHICLE_TYPE}
                    value={props.vehicleTypeValue}
                    options={props.vehicleTypeOptions}
                    labelTranslationKey={vehicleTypeTranslationKey}
                    provideAllTranslationKey="catalog-filters-vehicle-type-select-label-all"
                    onChange={props.onVehicleTypeChange}
                    onToolTipHover={() => props.onToolTipHover('Vehicle Type')}
                    provideAllOption={true}
                    tooltipContent="There should be some text here"
                    highlight={!props.vehicleTypeValue}
                />
            </TranslationContainer>
        </FilterSection>
    );
}

Additional.propTypes = {
    vehicleTypeValue: PropTypes.string.isRequired,
    vehicleTypeOptions: PropTypes.array.isRequired,
    opened: PropTypes.bool.isRequired,
    resettable: PropTypes.bool.isRequired,
    onActionClick: PropTypes.func.isRequired,
    onVehicleTypeChange: PropTypes.func.isRequired,
    onToolTipHover: PropTypes.func.isRequired,
};

export { Additional };
